export const COLUMNS = [
  { id: 'name', label: 'Проект', minWidth: 450 },
  { id: 'number', label: 'Порядковый номер', minWidth: 450 },
  {
    id: 'population',
    label: 'Действия',
    minWidth: 50,
  },
];
